import { createAsyncReducer } from '../../standard-actions';
import {
    IEditPaymentMethodAction,
    IEditPaymentMethodSuccessAction,
    IEditPaymentMethodErrorAction
} from '../actions/edit-payment-methods';
import { IBillingState } from '../state';
import { initialState } from '../state/initial-state';

export type EditPaymentMethodAction
    = IEditPaymentMethodAction
    | IEditPaymentMethodSuccessAction
    | IEditPaymentMethodErrorAction;

const init = (state: IBillingState, action: EditPaymentMethodAction) => ({
    ...state,
    editPaymentMethod: {
        ...state.editPaymentMethod,
        status: action.status
    }
});

const success = (state: IBillingState, action: EditPaymentMethodAction) => {
    const editData = (action as IEditPaymentMethodSuccessAction).data.data;
    const updatedPMethods = state.paymentMethods?.data?.paymentMethods?.map((v) => {
        return editData?.paymentMethod?.tid === v.tid ? editData.paymentMethod : v;
    });
    return {
        ...state,
        paymentMethods: {
            ...state.paymentMethods,
            data: {
                ...state.paymentMethods.data,
                paymentMethods: updatedPMethods,
            }
        },
        editPaymentMethod: {
            status: action.status,
            data: editData
        }
    }

};

const failure = (state: IBillingState, action: EditPaymentMethodAction) => ({
    ...state,
    editPaymentMethod: {
        ...initialState.editPaymentMethod,
        status: action.status,
        error: (action as IEditPaymentMethodErrorAction).error,
        errorCode: (action as IEditPaymentMethodErrorAction).errorCode
    }
});

const notStarted = (state: IBillingState, action: EditPaymentMethodAction) => ({
    ...state,
    editPaymentMethod: {
        status: action.status,
        data: null
    }
});

export const editPaymentMethodReducer = createAsyncReducer(initialState, init, success, failure, notStarted);
